import React from 'react'

export function UpdatesLog() {
  const entries: Array<{ date: string; title: string; items: string[] }> = [
    {
      date: '2025-10-09',
      title: 'Help & Tickets — smarter UX + attachments',
      items: [
        'Help is now lazy‑loaded to keep the app fast',
        'Ticket reply notifications: badge on Help button + toast; open threads auto‑refresh',
        'Templates for Bug / Question / Idea + opt‑in diagnostics appended to message',
        'Validation with a short cooldown to reduce noise',
        'Friendlier UI: relative times and status chips',
        'Auto‑refresh while viewing a thread; periodic background refresh',
        'Offline drafts and retry queues for tickets and replies',
        'Admin: quick filters by status/type + subject search',
        'New: image attachments for tickets (private, signed links in Help/Admin)'
      ]
    },
    {
      date: '2025-10-08',
      title: 'Personal greeting + gender icons + hover lift + auto-refresh',
      items: [
        'Dashboard: personal greeting — shows your name for a friendlier feel',
        'Dashboard: gender-based character (male/female/neutral) replaces the armpump when no custom avatar is picked',
        'UI: subtle hover lift on desktop for welcome/KPI/promo cards',
        'Sessions: thresholds auto-refresh on app focus and every minute (prefers global thresholds when available)',
        'Challenges: page simplified to show only the daily challenge (clean and focused)'
      ]
    },
    {
      date: '2025-10-07',
      title: 'Armed guidance + audio cues + cloud refresh + nav refresh',
      items: [
        'Guidance is now strictly gated: “Go down” alleen als je boven armed bent; “Go up” alleen als je beneden armed bent',
        'Kleine “Armed” indicator naast de teller zodat je weet dat de volgende top telt',
        'Audio cues: hoge piep bij top-armed, lage piep bij bottom-armed',
        'Dashboard: “Refresh cloud” verhuisd naar het 3‑puntjes menu; minder rommel op het scherm',
        'Nieuwe navigatie: Dashboard als home, Challenges heeft eigen tab, Social en Profile ongewijzigd',
        'Activity als modal vanuit Dashboard (“Last 7 days → View”)',
        'Centrale Play‑knop in de bottom bar, half overlappend voor snelle start'
      ]
    },
    {
      date: '2025-10-06',
      title: 'UI polish + Social calmer + offline sync tweaks',
      items: [
        'Social: leaderboards ingeklapt standaard; vriendelijkere lege status',
        'PR-momenten: toasts gedebounced; max één confetti per PR/best day',
        'Offline: “Saved — will sync when online”; subtiele “Synced …” bevestiging bij reconnect',
        'Dashboard: eenvoudige PR-streak chip toegevoegd',
        'Telemetry (dev): minimale logs bij succesvolle/failed background sync'
      ]
    },
    {
      date: '2025-10-06',
      title: 'Simple mode + readiness hints',
      items: [
        'New hints when you are not "ready" (e.g., wrists below shoulders, body flat, hips aligned)',
        'Simple mode: counts without dwell/cadence clocks — purely top/bottom',
        'Small threshold fine-tuning for more reliable counting',
        'See CHANGELOG for details'
      ]
    },
    {
      date: '2025-10-06',
      title: 'Counting reliability + default muted audio',
      items: [
        'Audio cues are off by default (you can enable them; your choice is remembered)',
        'Progress ring now fills 100% at the counted bottom position',
        'Auto-lenient fallback: if no count but deep bend is seen, counting is briefly more forgiving'
      ]
    },
    {
      date: '2025-10-06',
      title: 'Posture gating + Admin scroll + Install prompt',
      items: [
        'Stricter posture: horizontal body and wrists below shoulders required',
        'Admin: long ticket content now scrolls in the modal',
        'Install app prompt: quick access to a full-screen experience',
        'Settings: PR confetti toggle available'
      ]
    },
    {
      date: '2025-10-06',
      title: 'Guidance + Audio + Camera Fit/Fill + Tickets',
      items: [
        'Guidance always visible: “Go down/Go up” with hysteresis',
        'Audio cues synced to direction; distinct out-of-frame chirp',
        'Camera Fit/Fill toggle with correct overlay mapping',
        'User can view their own tickets and reply',
        'Auth screen branding updated (white logo + gradient)',
        'Mobile: improved full-screen behavior and micro-animations'
      ]
    }
  ]
  return (
    <div className="container">
      <div className="hero">
        {entries.map((e,i) => (
          <div key={i} className="list" style={{margin:0}}>
            <div className="list-item" style={{display:'grid', gap:6}}>
              <div style={{fontWeight:900}}>{e.title}</div>
              <div style={{fontSize:12, opacity:0.8}}>{e.date}</div>
              <ul style={{margin:'6px 0 0 18px'}}>
                {e.items.map((it, j) => <li key={j}>{it}</li>)}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
